import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Review } from '../models/admin.models';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backendUrl}/reviews`;

  submitReview(reviewData: Partial<Review>): Observable<any> {
    return this.http.post(this.apiUrl, reviewData);
  }

  getProductsReviews(productId: string, page: number = 1, limit: number = 10): Observable<Review[]> {
    return this.http.get<Review[]>(`${this.apiUrl}/product/${productId}?page=${page}&limit=${limit}`);
  }
}
